import React from 'react';
import { X } from 'lucide-react';
import theme from '../../constants/theme';

export default function CaseStudyModal({ caseStudy, onClose }) {
  if (!caseStudy) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-10 bg-black/60 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="bg-[#fbfbf5] w-full max-w-5xl max-h-[90vh] overflow-y-auto border-4 p-6 md:p-10 relative animate-fade-in-up"
        style={{ borderColor: theme.primary }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 md:top-6 md:right-6 hover:scale-110 transition-transform"
          style={{ color: theme.primary }}
        >
          <X size={32} />
        </button>

        {/* Title */}
        <h2
          className="font-retropix text-2xl md:text-4xl mb-6 pr-10"
          style={{ color: theme.primary }}
        >
          {caseStudy.title}
        </h2>

        {/* YouTube Embed */}
        <div
          className="mb-8 border-2 overflow-hidden"
          style={{ borderColor: 'rgba(26, 26, 26, 0.1)' }}
        >
          {/* 16:9 responsive wrapper */}
          <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
            <iframe
              src={`https://www.youtube.com/embed/${caseStudy.youtubeId}?rel=0&modestbranding=1`}
              title={caseStudy.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 'none',
              }}
            />
          </div>
        </div>

        {/* Problem / Solution / Outcome */}
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <h4 className="font-bold uppercase tracking-wider text-xs mb-3 opacity-50">01. The Problem</h4>
            <p className="text-sm leading-relaxed">{caseStudy.problem}</p>
          </div>
          <div>
            <h4 className="font-bold uppercase tracking-wider text-xs mb-3 opacity-50">02. The Solution</h4>
            <p className="text-sm leading-relaxed">{caseStudy.solution}</p>
          </div>
          <div>
            <h4
              className="font-bold uppercase tracking-wider text-xs mb-3 opacity-50"
              style={{ color: theme.primary }}
            >
              03. The Outcome
            </h4>
            <p className="text-sm leading-relaxed font-bold">{caseStudy.outcome}</p>
          </div>
        </div>
      </div>
    </div>
  );
}